// This can be made into a helper function in the qrcode component itself

/* eslint-disable @typescript-eslint/no-extraneous-class */
import * as QRCode from 'qrcode';
import { GenerationType, QrCodeOptions } from './qr-code.models';

export class QrCodeHelper {
  static generateEncodedDataUrl(value: string, options: QrCodeOptions): Promise<string> {
    if (!value) {
      throw new Error('[NgQrGen] value was null');
    }
    if (!options) {
      throw new Error('[NgQrGen] options were not set.');
    }
    if (options.type !== GenerationType.Image) {
      throw new Error(
        '[NgQrGen] options.type should be of value GenerationType.Image when generating an Encoded Data Url.'
      );
    }
    if (!options.imageType) {
      throw new Error('[NgQrGen] options.imageType should be set, when generating an Encoded Data Url.');
    }

    return new Promise<string>((resolve, reject) => {
      // Object must be hard-copied, due to type property override
      const { imageType, ...otherOptions } = options;
      const formlessOptions = {
        ...otherOptions,
        type: imageType,
      };
      QRCode.toDataURL(value, formlessOptions, (err: Error, url: string) => {
        if (err) {
          console.error(err);
          reject(err);
        } else {
          resolve(url);
        }
      });
    });
  }

  static generateString(value: string, options: QrCodeOptions): Promise<string> {
    if (!value) {
      throw new Error('[NgQrGen] value was null');
    }
    if (!options) {
      throw new Error('[NgQrGen] options were null');
    }

    return new Promise<string>((resolve, reject) => {
      // Object must be hard-copied, due to type property override
      const { ...otherOptions } = options;
      const formlessOptions = {
        ...otherOptions,
        type: 'svg',
      };
      QRCode.toString(value, formlessOptions, (err: Error, url: string) => {
        if (err) {
          console.error(err);
          reject(err);
        } else {
          resolve(url);
        }
      });
    });
  }
}
